document.addEventListener('click', e => {
  let element = e.target as HTMLElement;
  const data: Record<string, unknown> & { event?: string } = {};
  let hasKey = false;
  do {
    for (const [key, value] of Object.entries(element.dataset)) {
      if (key.startsWith('ga')) {
        data[key.substring(2).toLowerCase()] = value;
        hasKey = true;
      }
    }

    if (hasKey) {
      break;
    }

    if (element.parentElement) {
      element = element.parentElement;
    } else {
      break;
    }

  } while (element.parentElement);

  if (hasKey && 'dataLayer' in window) {
    const event = `toolkit_${data.event}`;
    delete data.event;
    if (window.gtag) {
      window.gtag('event', event, data);
    }
  }
})

declare interface Window {
  //dataLayer: unknown[];
  gtag: Function;
}